import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeListItemComponent } from './badge-list-item.component';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    BadgeListItemComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    PipesModule,
    NgbModule
  ],
  exports: [
    BadgeListItemComponent
  ]
})
export class BadgeListItemModule { }
